module.exports = __webpack_public_path__ + "static/img/graphic3.46223a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/graphic3.svg
// module id = 717
// module chunks = 21